import { PostQuestionnairePayload } from 'api/typegen/client/questionnaire/post';
import fetchWebApi from 'api/fetchWebApi';

const postQuestionnaireApiCall = async (
  payload: PostQuestionnairePayload,
): Promise<void> =>
  fetchWebApi('/client/questionnaire', undefined, {
    method: 'post',
    body: JSON.stringify(payload),
  });

export default postQuestionnaireApiCall;
